import {
  editIdState,
  editPwState,
  guardianUserState,
  studentUserState,
} from "../states/user";
import { joinCommState } from "@/common/states/recoilInfo";
import { useRecoilState } from "recoil";
import { ChangeEvent, useState } from "react";

export const useJoinFormHandlers = () => {
  const [editId, setEditId] = useRecoilState(editIdState);
  const [editPw, setEditPw] = useRecoilState(editPwState);
  const [student, setStudent] = useRecoilState(studentUserState);
  const [joinComm, setJoinComm] = useRecoilState(joinCommState);
  const [guardian, setGuardian] = useRecoilState(guardianUserState);
  const [guardianExistRecoil, setGuardianExistRecoil] =
    useRecoilState(studentUserState);
  const [guardianExist, setGuardianExist] = useState<string | null>(
    guardianExistRecoil.guardianAccExist
  );
  const [schoolType, setSchoolType] = useState<string>();

  const handleIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setJoinComm((prev) => ({
      ...prev,
      userId: value,
    }));
  };

  const handleEditIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEditId((prev) => ({
      ...prev,
      userId: value,
    }));
  };

  const handlePwChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setJoinComm((prev) => ({
      ...prev,
      password: value,
    }));
  };

  const handleEditPwChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEditPw((prev) => ({
      ...prev,
      newPassword: value,
    }));
  };

  const handlePwCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setJoinComm((prev) => ({
      ...prev,
      passwordCheck: value,
    }));
  };

  const handleAccountFindQuestionChange = (value: string) => {
    setJoinComm((prev) => ({
      ...prev,
      accountFindQuestion: value,
    }));
  };

  const handleQnAChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setJoinComm((prev) => ({
      ...prev,
      questionAnswer: value,
    }));
  };

  const handleGuardianExistChange = (value: string) => {
    setGuardianExist(value);
    setGuardianExistRecoil((prev) => ({
      ...prev,
      guardianAccExist: value,
    }));
  };

  const handleNameChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "student" | "guardian"
  ) => {
    const { value } = e.target;
    type === "student"
      ? setStudent((prev) => ({
          ...prev,
          name: value,
        }))
      : setGuardian((prev) => ({
          ...prev,
          name: value,
        }));
  };

  const handleBirthChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "student" | "guardian"
  ) => {
    const { value } = e.target;
    const birthDateValue = new Date(value);

    type === "student"
      ? setStudent((prev) => ({
          ...prev,
          birth: isNaN(birthDateValue.getTime()) ? undefined : birthDateValue,
        }))
      : setGuardian((prev) => ({
          ...prev,
          birth: isNaN(birthDateValue.getTime()) ? undefined : birthDateValue,
        }));
  };

  const handleGenderChange = (gender: string) => {
    setStudent((prev) => ({
      ...prev,
      gender: gender,
    }));
  };

  const handleEntityTypeChange = (value: string) => {
    setJoinComm((prev) => ({
      ...prev,
      entityType: value,
      organizationName: value === "organization" ? prev.organizationName : "",
    }));
  };

  const handleNumberChange = (
    e: ChangeEvent<HTMLInputElement>,
    type: "student" | "guardian"
  ) => {
    const phoneNumber = e.target.value.replace(/[^0-9]/g, "");
    let formattedNumber = "";

    if (phoneNumber.length < 4) {
      formattedNumber = phoneNumber;
    } else if (phoneNumber.length < 7) {
      formattedNumber =
        phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3);
    } else if (phoneNumber.length < 11) {
      formattedNumber =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 7) +
        "-" +
        phoneNumber.substring(7);
    } else {
      formattedNumber =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 7) +
        "-" +
        phoneNumber.substring(7);
    }

    type === "student"
      ? setStudent((prev) => ({
          ...prev,
          tel: formattedNumber,
        }))
      : setGuardian((prev) => ({
          ...prev,
          tel: formattedNumber,
        }));
  };

  const handleSchoolTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setStudent((prev) => ({
      ...prev,
      schoolType: value,
      schoolId: "",
    }));
    setSchoolType(value);
  };

  const handleSchoolIdChange = (value: string) => {
    setStudent((prev) => ({
      ...prev,
      schoolId: value,
    }));
  };

  const handleStudentIdNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    setStudent((prev) => ({
      ...prev,
      studentIdNumber: value,
    }));
  };

  const handleEtcNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setStudent((prev) => ({
      ...prev,
      schoolId: value,
    }));
  };

  const handleOrganizationNameChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    setJoinComm((prev) => ({
      ...prev,
      organizationName: value,
    }));
  };

  return {
    editId,
    editPw,
    student,
    guardian,
    joinComm,
    schoolType,
    guardianExist,
    guardianExistRecoil,
    handleIdChange,
    handlePwChange,
    handleQnAChange,
    handleNameChange,
    handleBirthChange,
    handleNumberChange,
    handleGenderChange,
    handleEditIdChange,
    handleEditPwChange,
    handlePwCheckChange,
    handleEtcNameChange,
    handleSchoolIdChange,
    handleEntityTypeChange,
    handleSchoolTypeChange,
    handleGuardianExistChange,
    handleStudentIdNumberChange,
    handleOrganizationNameChange,
    handleAccountFindQuestionChange,
  };
};
